import React from 'react';

import {observer, inject} from 'mobx-react';

import Header from '../components/Header';
import SideMenu from '../components/SideMenu';
import Gravatar from 'react-gravatar';
import Typography from 'material-ui/Typography';
import VehiclesHelper from '../helpers/Vehicles';
import { Button, Snackbar, CircularProgress } from "material-ui";
import { TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from 'material-ui';
import vehicle_store from "../stores/vehicle";

class ReportContainer extends React.Component {

    constructor() {
        super();

        this.state = {
            open: false,
            device_id: null
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        const report_store = this.props.report_store;
        report_store.fetch();
    }

    getItems(items) {
        const { app_store } = this.props;

        return items.map((vehicle, index) => {
            let phones = vehicle.phones || {};

            return (
                <tr key={index} id={index}>
                    <td>
                        <div className="user-info">
                            <Gravatar email={vehicle.email || 'unknow@polibrasnet.com.br'} size={32} default="mm" className="avatar" />
                            <div>
                                <h4>{vehicle.name}</h4>
                                <small>{phones.main || 'Sem número'}</small>
                            </div>
                        </div>
                    </td>

                    <td>{vehicle.email}</td>
                    <td>{vehicle.vehicle_id}</td>
                    { app_store.configurations.use_temperature && <td>{vehicle.device_id}</td> }
                    { app_store.configurations.use_temperature &&
                        <td>{ VehiclesHelper.isCool(vehicle) ? 'Frio' : vehicle.trunk_category} </td>
                    }
                </tr>
            );
        });
    }

    handleOpen() {
        this.setState({ open: true });
    };

    handleClose() {
        const vehicle_store = this.props.vehicle_store;

        vehicle_store.reset();

        this.setState({ open: false });
    };

    async confirm() {
        let vehicle_store = this.props.vehicle_store;
        const params = {
            vehicle_id: document.getElementById('vehicle_id').value.toUpperCase(),
            device_id: document.getElementById('device_id').value,
        };

        let vehicle = vehicle_store.vehicle;

        if (params.vehicle_id === vehicle.id && this.state.device_id === params.device_id) {
            await vehicle_store.create(params);

            if (!vehicle_store.has_error_create) {
                this.handleClose();

                this.fetchData();

                setTimeout(()=> {
                    vehicle_store.success = false;
                }, 2000);
            }
        } else {
            this.search();
        }
    }

    async search() {
        let vehicle_store = this.props.vehicle_store;

        const params = {
            vehicle_id: document.getElementById('vehicle_id').value.toUpperCase(),
            device_id: document.getElementById('device_id').value,
        };

        this.setState({
            device_id: params.device_id
        });

        await vehicle_store.fetch(params.vehicle_id);
    }

    showDeviceExists(device) {
        return (
            <DialogContentText>
                <p style={{color: 'red', fontWeight: '500'}}>Essa placa já possui um sensor associado.</p>
                <p style={{color: 'red'}}><span style={{fontWeight: '500'}}>Sensor: </span>{ device.id }</p>
            </DialogContentText>
        )
    }

    showInfoVehicle() {
        return (
            <div>
                <DialogContentText>
                    <p>Informações do Veículo</p>
                </DialogContentText>

                <p>
                    Motorista: { vehicle_store.vehicle && vehicle_store.vehicle.user ? vehicle_store.vehicle.user.display_name : null}
                </p>
                <p>
                    Email: { vehicle_store.vehicle && vehicle_store.vehicle.user ? vehicle_store.vehicle.user.email : null}
                </p>
            </div>
        );
    }

    render() {
        const { report_store, vehicle_store, app_store } = this.props;
        const items = report_store.vehicles || [];

        return (
            <div>
                <Header/>
                <div className="container-fw">
                    <SideMenu />

                    <div className="content">
                        <div className="flex-container">

                            <Dialog
                                open={this.state.open}
                                onClose={this.handleClose.bind(this)}
                                aria-labelledby="form-dialog-title">
                                <DialogTitle id="form-dialog-title">Associar Sensor</DialogTitle>
                                <DialogContent>
                                    {
                                        (vehicle_store.fetching || vehicle_store.creating) &&
                                        <div className="text-center">
                                            <div><CircularProgress /></div>
                                        </div>
                                    }

                                    {
                                        vehicle_store.vehicle &&
                                        vehicle_store.vehicle.devices &&
                                        vehicle_store.vehicle.devices.length > 0 && this.showDeviceExists(vehicle_store.vehicle.devices[0])
                                    }

                                    {
                                        vehicle_store.has_error &&
                                        <p style={{color: 'red', fontWeight: '500'}}>Ocorreu um erro ao buscar as informações do veículo</p>
                                    }

                                    {
                                        vehicle_store.has_error_create &&
                                        <p style={{color: 'red', fontWeight: '500'}}>Ocorreu um erro ao associar o veículo ao sensor</p>
                                    }

                                    {
                                        vehicle_store.is_fetched && !vehicle_store.has_error &&
                                        (!vehicle_store.vehicle || !vehicle_store.vehicle.id) &&
                                        <p style={{color: 'red', fontWeight: '500'}}>Essa placa está não cadastrada</p>
                                    }

                                    {
                                        vehicle_store.vehicle && vehicle_store.vehicle.id && this.showInfoVehicle()
                                    }

                                    <Snackbar
                                        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                                        open={vehicle_store.success}
                                        message={<span>Sensor associado com sucesso!</span>} />

                                    <div>
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            id="vehicle_id"
                                            label="Placa do Veículo"
                                            type="text"
                                            required={true}
                                            fullWidth
                                        />

                                        <TextField
                                            margin="dense"
                                            id="device_id"
                                            label="Número do Sensor"
                                            type="text"
                                            required={true}
                                            fullWidth
                                        />
                                    </div>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleClose.bind(this)} color="primary">
                                        Cancelar
                                    </Button>

                                    {
                                        (vehicle_store.vehicle &&
                                            vehicle_store.vehicle.id &&
                                            vehicle_store.vehicle.devices &&
                                            vehicle_store.vehicle.devices.length < 1) ?
                                            <Button onClick={this.confirm.bind(this)} color="primary">
                                                Confirmar
                                            </Button>
                                            :
                                            <Button onClick={this.search.bind(this)} color="primary">
                                                Próximo
                                            </Button>
                                    }
                                </DialogActions>
                            </Dialog>

                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'nowrap',
                                justifyContent: 'space-between'
                            }}>
                                <p>
                                    <Typography type="title" gutterBottom>Motoristas</Typography>
                                </p>

                                {
                                    app_store.configurations.use_temperature && (
                                        <Button color="primary" onClick={this.handleOpen.bind(this)}>
                                            <i className={'material-icons'}>add</i> Associar sensor
                                        </Button>
                                    )
                                }
                            </div>

                            <Snackbar
                                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                                open={report_store.fetching}
                                message={<span>Carregando...</span>} />

                            {
                                !report_store.fetching && !items.length ? <div className="text-center">Nenhum motorista foi encontrado.</div> : null
                            }

                            {
                                items.length > 0 ?
                                    <div>
                                        <p><Typography type="caption" gutterBottom>Total: { items.length }</Typography></p>

                                        <div className="monitoring-table-container">
                                            <table className="monitoring-table">
                                                <thead>
                                                <tr>
                                                    <th>Motorista</th>
                                                    <th>Email</th>
                                                    <th>Placa</th>
                                                    { app_store.configurations.use_temperature && (<th>Sensor</th>) }
                                                    { app_store.configurations.use_temperature && (<th>Categoria do Baú</th>) }
                                                </tr>
                                                </thead>

                                                <tbody>
                                                { this.getItems(items) }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

let container = observer(ReportContainer);
container = inject(['report_store'], ['vehicle_store'], ['app_store'])(container);

export default container;



// WEBPACK FOOTER //
// ./src/containers/report.js